import { Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  Align,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  LinearScale,
  Title,
} from "chart.js";
import styled from "@emotion/styled";
import { ThemeProps } from "types/theme";
import { withTheme } from "@emotion/react";
import { rgba } from "polished";
import { Bar } from "react-chartjs-2";

ChartJS.register(LinearScale, CategoryScale, BarElement, Title);

const ChartWrapper = styled.div`
  height: 160px;
  position: relative;
`;

interface Props {
  mostCommonEmotions: { [key: string]: number };
  mostCommonIntents: { [key: string]: number };
}

const InteractionGraphs: React.FC<ThemeProps & Props> = ({
  mostCommonEmotions,
  mostCommonIntents,
  theme,
}) => {
  const { t } = useTranslation();

  const dataEmotions = {
    labels: Object.keys(mostCommonEmotions),
    datasets: [
      {
        data: Object.keys(mostCommonEmotions).map((a) => mostCommonEmotions[a]),
        backgroundColor: theme.palette.primary.main,
        borderColor: rgba(theme.palette.secondary.main, 0.33),
        hoverBackgroundColor: theme.palette.primary.main,
        hoverBorderColor: theme.palette.primary.main,
        barPercentage: 0.5,
        categoryPercentage: 0.5,
        borderRadius: 6,
      },
    ],
  };

  const dataIntents = {
    labels: Object.keys(mostCommonIntents),
    datasets: [
      {
        data: Object.keys(mostCommonIntents).map((a) => mostCommonIntents[a]),
        backgroundColor: theme.palette.primary.main,
        borderColor: rgba(theme.palette.secondary.main, 0.33),
        hoverBackgroundColor: theme.palette.primary.main,
        hoverBorderColor: theme.palette.primary.main,
        barPercentage: 0.5,
        categoryPercentage: 0.5,
        borderRadius: 6,
      },
    ],
  };

  const options = {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: true,
        text: t("social-reports.posts.most_common_emotions"),
        align: "center" as Align,
        font: {
          weight: 700,
        },
        padding: 8,
        fullSize: true,
      },
    },
    scales: {
      y: {
        grid: {
          display: false,
        },
        stacked: false,
        ticks: {
          stepSize: 20,
        },
      },

      x: {
        stacked: false,
        grid: {
          color: "transparent",
        },
      },
    },
  };

  return (
    <Grid container>
      <Grid item xs={12} lg={6}>
        <ChartWrapper>
          <Bar data={dataEmotions} options={options} />
        </ChartWrapper>
        {Object.keys(mostCommonEmotions).length === 0 && (
          <Typography>{t("empty_states.empty_stats.title")}</Typography>
        )}
      </Grid>
      <Grid item xs={12} lg={6}>
        <ChartWrapper>
          <Bar
            data={dataIntents}
            options={{
              ...options,
              plugins: {
                ...options.plugins,
                title: {
                  ...options.plugins.title,
                  text: t("social-reports.posts.most_common_intents"),
                },
              },
            }}
          />
        </ChartWrapper>
        {Object.keys(mostCommonIntents).length === 0 && (
          <Typography>{t("empty_states.empty_stats.title")}</Typography>
        )}
      </Grid>
    </Grid>
  );
};

export default withTheme(InteractionGraphs);
